import React, { createContext, useContext } from 'react';

export interface DashboardFooterContextValue {
  setFooter: (content: React.ReactNode) => void;
  clearFooter: () => void;
}

const DashboardFooterContext = createContext<DashboardFooterContextValue>({
  setFooter: () => {},
  clearFooter: () => {},
});

export const useDashboardFooter = (): DashboardFooterContextValue => {
  return useContext(DashboardFooterContext);
};

export default DashboardFooterContext;

